import script from "./nextStepButton.vue?vue&type=script&setup=true&lang=ts"
export * from "./nextStepButton.vue?vue&type=script&setup=true&lang=ts"

import "./nextStepButton.vue?vue&type=style&index=0&id=e190c60a&lang=scss&scoped=true"

import exportComponent from "D:\\work\\kaifengzimaoqu\\wt_front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e190c60a"]])

export default __exports__